<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/gZhqFY/tc-custom/9781035802821.jpg?1705375012568" alt="This image is the cover for the book Between Heaven and Earth"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Between Heaven and Earth
      </h1>
      <p class="bookDescription body article font2">
        <p>"THERE MUST BE AN ANGEL PLAYING WITH MY HEART."-THE EURYTHMICS Between Heaven and Earth is a contemporary love story that combines tragedy, companionship and divine intervention resulting in a powerful, moving and ultimately uplifting confirmation of what it means to be human. It is a poignant reminder of how the impact of death and grief affects people differently and how love and commitment can heal even the most broken of hearts. Teddy and Mona Goodson are childhood sweethearts. They are shattered to discover that she is seriously ill. Teddy becomes so absorbed in caring for his wife that he begins to neglect the needs of their son, Guy. Teddy therefore decides to engage the services of a child therapist, Dana Weston, who unbeknown to him, falls victim to her own catastrophe and heartbreak. When Guy is later diagnosed with Leukemia, the pain and grief intensify to the point where the powers-that-be on high seem to be conspiring against them. What follows is a complex interplay of relationships, memories, and synchronicity, touching, and in equal measures, both tragic and heart-warming, which reaches an emotionally charged and inspirational finale. When the human spirit is most tested, just when it seems all is lost, heaven and earth come together in a most profound way.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tony Wiseman
      </h2>
      
      <p class="authorDescription body article">Tony qualified in Law and practiced as a solicitor in his country of birth, South Africa before emigrating to Israel in 1961. Since then, after a stint on a kibbutz, he lectured at the Tel Aviv University and opened a chain of fast food restaurants and established a travel company specializing in incentive travel. The company won several international awards. For the last 34 years, as a highly respected trainer, he has conducted seminars in personal development and self-awareness in Israel, Turkey, the United Kingdom and around the world with his wife, Orit Josefi Wiseman in their company, Outlook. He has also been a coach and mentor, often dealing with issues pertaining to intimate relationships, which formed the basis of the book, Relationships I.Q., written together with Orit and published by Austin Macauley.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1e06b305